import type { TFunction } from 'i18next';
import type { LookalikeSegmentDefinition } from '../../../../../../../../../../modules/audiences/AudienceForm/types.ts';
import { formatReachValue } from './formatReachValue.ts';

export const getLookalikeReachRange = (definition: LookalikeSegmentDefinition, t: TFunction): string => {
  const { lookalike_segment_similarities, lookalike_segment_seed_aggregate } = definition;

  if (!lookalike_segment_similarities?.length && !lookalike_segment_seed_aggregate?.segment) {
    return t('N / A');
  }

  const reachValues: number[] = [];

  if (lookalike_segment_similarities?.length) {
    reachValues.push(
      ...lookalike_segment_similarities
        .map(derivedSegment => derivedSegment.segment.reach)
        .filter(reach => typeof reach === 'number')
    );
  }

  if (typeof lookalike_segment_seed_aggregate?.segment?.reach === 'number') {
    reachValues.push(lookalike_segment_seed_aggregate.segment.reach);
  }

  if (!reachValues.length) {
    return t('N / A');
  }

  const minReach = Math.min(...reachValues);
  const maxReach = Math.max(...reachValues);

  const minValue = minReach === 0 ? 0 : formatReachValue(t, minReach);

  return `${minValue} - ${formatReachValue(t, maxReach)}`;
};
